<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Terima kasih, Anda
                </div>

                <div>
                  telah berhasil mmengupdate stok
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#4828a1">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin untuk Update <b class="font-weight-bold black--text">Stok</b> ?

  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="saveStok()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#6948c6"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="false"
          width="900"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 mb-4 text-right popup-header">
              <div
                class="fs-20 font-weight-bold">
                Update Harga
              </div>

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#4828a1">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon> -->

              <v-icon 
                @click="dialog.form = false; reset();"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="">
              
              <ValidationObserver 
                ref="form">
                
                <div>
                <v-card flat class="mb-5" style="border-radius: 25px; border: 1px solid #E7E7E7;">
                  <v-card-text class="">
                    

                    <v-row>

                      <v-col
                          cols="12"
                          md="4" class="pt-0">
                          <ValidationProvider
                            name="Harga lainnya" 
                            rules="min_value:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              
                              Harga lainnya
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Harga lainnya"
                              
        
                              v-model="invoice.harga_lain"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                      <v-col
                          cols="12"
                          md="4" class="pt-0">
        
                          <ValidationProvider
                            name="Harga pengiriman" 
                            rules="min_value:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              
                              Harga pengiriman
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Harga pengiriman"
                              type="number"
        
                              v-model="invoice.harga_pengiriman"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                          </v-col>

                      <v-col
                          cols="12"
                          md="4" class="pt-0">
        
                          <ValidationProvider
                            name="Diskon" 
                            rules="min_value:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              
                              Diskon
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              type="number"
                              
        
                              placeholder="Diskon"
                              
                              
        
                              v-model="invoice.harga_disc"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                          </v-col>

                    </v-row>



                  </v-card-text>
                </v-card>
              </div>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-1">
              <v-spacer/>

              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#6948c6"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>

              <!-- <v-btn 
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.jual"
          @keydown.esc="dialog.jual = false"
          :fullscreen="true"
          width="900"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pb-4 text-right popup-header">
              <div
                class="fs-20 font-weight-bold">
                Update Harga Jual
              </div>

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#4828a1">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon> -->

              <v-icon 
                @click="dialog.jual = false; fetchDetail();"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="">
              <div class="fs-13 red--text">
                * Harga Jual yang diinputkan akan mengubah harga jual saat ini
              </div>
              <ValidationObserver 
                ref="form">
                <div class="view mt-5">
                  <div class="wrapper-harga-jual">
                    <table style="width: 100%" class="table">
                      <tr>
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: 1px solid #ededed;" class="pa-2">
                          Nama
                        </th>
                        <!-- <th>
                          Kode SKU
                        </th> -->
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                          Expired Date
                        </th>
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                          Qty
                        </th>
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                          Harga Beli
                        </th>
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                          PPN Beli
                        </th>
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                          Harga beli include PPN
                        </th>
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                          Harga Hpp Per Pcs
                        </th>
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                          Harga Jual Include PPN
                        </th>
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                          Harga Jual Include PPN
                        </th>
                        <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                          Harga Jual Saat Ini
                        </th>
                      </tr>
                      <tr v-for="(item, index) in form.varian_arr" :key="index">
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: 1px solid #ededed;" class="pa-2">
                          {{ item.name }}
                          <div>({{ item.sku }})</div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                          {{ item.expired_date | date }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                          {{ item.qty*1 | number }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                          {{ item.harga_beli | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                          {{ item.ppn_beli }}%
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                          {{ item.harga_beli_ppn | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                          {{ item.pricelist_pcs_ppn_before | price }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                          <ValidationProvider
                            :name="`Harga lainnya ${item.name} `" 
                            rules="min_value:0" 
                            v-slot="{ errors }">
                            <v-currency-field
                              v-on:keydown.enter.prevent="saveHargaJual()"
                              
                              filled
                              rounded
                              dense
                              solo
                              hide-details
        
                              color="#4828a1"
                              placeholder="Harga lainnya"
                              
        
                              v-model="item.harga_hpp_pcs"
                              :error-messages="errors"
                              
                              style="border-radius: 10px; width: 150px; max-width: 150px; min-width: 150px;">
                            </v-currency-field>
                          </ValidationProvider>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                          <ValidationProvider
                            :name="`Diskon ${item.name} `" 
                            rules="min_value:0" 
                            v-slot="{ errors }">
                            <v-currency-field
                              v-on:keydown.enter.prevent="saveHargaJual()"
                              v-on:change="change_harga_jual_ppn(index)"
                              
                              filled
                              rounded
                              dense
                              solo
                              hide-details
        
                              color="#4828a1"
                              type="number"
                              
        
                              placeholder="Diskon"
                              
                              
        
                              v-model="item.pricelist_pcs_ppn"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                          <ValidationProvider
                            :name="`Harga pengiriman ${item.name} `" 
                            rules="min_value:0" 
                            v-slot="{ errors }">
                            <v-currency-field
                              v-on:keydown.enter.prevent="saveHargaJual()"
                              
                              filled
                              rounded
                              readonly
                              dense
                              solo
                              hide-details
        
                              color="#4828a1"
                              placeholder="Harga pengiriman"
                              type="number"
        
                              v-model="item.pricelist_exclude_ppn"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                        </td>
    
                      </tr>
                    </table>
                  </div>
                </div>
                
                <!-- <div v-for="(item, index) in form.varian_arr" :key="index">
                <v-card flat class="mb-5" style="border-radius: 25px; border: 1px solid #E7E7E7;">
                  <v-card-text class="">

                    <div>
    
                      <div>
                        <div class="fs-16 font-weight-bold label-input">
                          {{ item.name }}
                        </div>
                        <div class="mb-1">
                          <span>Kode SKU</span>: <span>{{ item.sku }}</span>
                        </div>
                        <div class="mb-1">
                          <span>Unit</span>: <span>{{ item.unit }}</span>
                        </div>
                        <div class="mb-1">
                          <span>Expired Date</span>: <span>{{ item.expired_date | date }}</span>
                        </div>
                          <div class="d-flex">
                            <div class="pr-4">
                              <div class="">
                                
                                Qty
                              </div>
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.qty*1 | number }}
                              </div>
                            </div>
                            <div class="">
                              <div class="">
                                
                                Harga Beli
                              </div>
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.harga_beli | price }}
                              </div>
                            </div>
                            <div class="">
                              <div class="">
                                
                                PPN Beli
                              </div>
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.ppn_beli }}%
                              </div>
                            </div>
                            <div class="">
                              <div class="">
                                
                                Harga beli include PPN
                              </div>
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.harga_beli_ppn | price }}
                              </div>
                            </div>
                          </div>




                      </div>
                    </div>
                    

                    <v-row>

                      <v-col
                          cols="12"
                          md="4" class="pt-0">
                          <ValidationProvider
                            :name="`Harga lainnya ${item.name} `" 
                            rules="min_value:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              
                              Harga Hpp Per Pcs
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="saveHargaJual()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Harga lainnya"
                              
        
                              v-model="item.harga_hpp_pcs"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                      <v-col
                          cols="12"
                          md="4" class="pt-0">
        
                          <ValidationProvider
                            :name="`Diskon ${item.name} `" 
                            rules="min_value:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              
                              Harga Jual Include PPN
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="saveHargaJual()"
                              v-on:change="change_harga_jual_ppn(index)"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              type="number"
                              
        
                              placeholder="Diskon"
                              
                              
        
                              v-model="item.pricelist_pcs_ppn"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                          </v-col>

                      <v-col
                          cols="12"
                          md="4" class="pt-0">
        
                          <ValidationProvider
                            :name="`Harga pengiriman ${item.name} `" 
                            rules="min_value:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              
                              Harga Jual Per Pcs
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="saveHargaJual()"
                              
                              filled
                              rounded
                              readonly
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Harga pengiriman"
                              type="number"
        
                              v-model="item.pricelist_exclude_ppn"
                              :error-messages="errors"
                              
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                          </v-col>

                    </v-row>



                  </v-card-text>
                </v-card>
              </div> -->
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="">
              <v-spacer/>

              <v-btn 
                @click="saveHargaJual()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#6948c6"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>

              <!-- <v-btn 
                @click="dialog.jual = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Detail Penerimaan
          </div>

          <v-row
            class="">
            <v-col 
              cols="12"
              class="px-0">
              <v-card 
                flat
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text
                    v-if="process.form" 
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>

                  <v-card-text v-if="!process.form">
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Distributor Amanata" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>
                        
                        <v-col
                          cols="12"
                          md="12" class="pt-0">
                          <v-row>
                            <v-col cols="12" md="3">
                              <div 
                                class="fs-15 label-input">
                                Pembelian
                              </div>
        
                              <div class="fs-17 font-weight-bold label-input">
                                {{ form.po_number }}
                              </div>
                            </v-col>
                            <v-col cols="12" md="3">
                              <div 
                                class="fs-15 label-input">
                                
                                Nomor Penerimaan
                              </div>
        
                              <div class="fs-17 font-weight-bold label-input">
                                {{ form.number }}
                              </div>
                            </v-col>
                            <v-col cols="12" md="3">
                              <div 
                                class="fs-15 label-input">
                                
                                Nomor Surat Jalan
                              </div>
        
                              <div class="fs-17 font-weight-bold label-input">
                                {{ form.no_surat_jalan }}
                              </div>
                            </v-col>
                            <v-col cols="12" md="3">
                              <div class="fs-15 label-input">
                              
                              
                                Tanggal Input
                              </div>
                
                              <div class="fs-17 font-weight-bold label-input">
                                {{ form.date | date }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>

                        <!-- <v-col cols="5">
                          <div class="fs-15 label-input">
                            Bukti
                          </div>

                          <div v-if="bukti === 'gambar'">

                                <v-card 
                                  flat
                                  width="350"
                                  height="350"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  
  
                                  <v-img 
                                    contain
                                    height="350"
                                    :src="gambar_url" 
                                    :alt="gambar_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      
  
                                    </div>
                                  </v-img>
                                </v-card>
                          </div>

                          <div v-if="bukti === 'pdf'">

                                <v-card 
                                  flat
                                  height="350"
                                  width="350"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  

                                  <div>
                                    <iframe :src="pdf_url" height="350" frameborder="0"></iframe>
                                  </div>
  
                                </v-card>
                          </div>

                          
                        </v-col> -->
                        
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                </v-card-text>
              </v-card>

              <v-card flat class="mb-5 mt-6" style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text class="">
                  <div class="mb-2 fs-16 font-weight-bold">
                    Data Varian
                  </div>
                  <v-divider class="mb-6"></v-divider>
                  <v-row>
                    <v-col cols="6">
                      <div class="fs-15 font-weight-bold mb-0">
                        Data Invoice
                      </div>
                    </v-col>
                    <v-col cols="6" style="border-left: 1px solid #E7E7E7;">
                      <div class="fs-15 font-weight-bold mb-0">
                        Update Harga Invoice
                      </div>
                    </v-col>
                  </v-row>
                  <div v-for="(item, index) in form.varian_arr" :key="index">
                    <!-- <v-card flat class="mb-5" style="border-radius: 25px; border: 1px solid #E7E7E7;">
                      <v-card-text class=""> -->
                        <v-row>
                          <v-col cols="12" md="6">
                            <!-- <div class="fs-17 font-weight-bold mb-4">
                              Data Invoice
                            </div> -->
    
                            <div>
    
                              <div>
                                <div class="fs-14 label-input">
                                  {{ item.name }}
                                </div>
                                <div>
                                  <span>Kode SKU</span>: <span>{{ item.sku }}</span>
                                </div>
                                <div>
                                  <span>Unit</span>: <span>{{ item.unit }}</span>
                                </div>
                                <div>
                                  <span>Expired Date</span>: <span>{{ item.expired_date | date }}</span>
                                </div>
    
                                <div class="d-flex">
                                  <div class="fs-15 label-input">
                                    
                                    Qty
                                  </div>
                                  <div class="ml-auto fs-17 font-weight-bold label-input">
                                    {{ item.qty*1 | number }}
                                  </div>
                                </div>
    
                                <div class="d-flex">
                                  <div class="fs-15 label-input">
                                    
                                    Harga Beli
                                  </div>
                                  <div class="ml-auto fs-17 font-weight-bold label-input">
                                    {{ item.harga_beli | price }}
                                  </div>
                                </div>
    
                                <div class="d-flex">
                                  <div class="fs-15 label-input">
                                    
                                    PPN Beli
                                  </div>
                                  <div class="ml-auto fs-17 font-weight-bold label-input">
                                    {{ item.ppn_beli }}%
                                  </div>
                                </div>
    
                                <div class="d-flex">
                                  <div class="fs-15 label-input">
                                    
                                    Harga beli include PPN
                                  </div>
                                  <div class="ml-auto fs-17 font-weight-bold label-input">
                                    {{ item.harga_beli_ppn | price }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" style="border-left: 1px solid #E7E7E7;">
                            <!-- <div class="fs-17 font-weight-bold mb-4">
                              Update Harga Invoice
                            </div> -->
    
                            <div>
    
                              <div>
                                <div class="fs-14 label-input">
                                  {{ item.name }}
                                </div>
                                <div>
                                  <span>Kode SKU</span>: <span>{{ item.sku }}</span>
                                </div>
                                <div>
                                  <span>Unit</span>: <span>{{ item.unit }}</span>
                                </div>
                                <div>
                                  <span>Expired Date</span>: <span>{{ item.expired_date | date }}</span>
                                </div>
    
                                <div class="d-flex">
                                  <div class="fs-15 label-input">
                                    
                                    Qty
                                  </div>
                                  <div class="ml-auto fs-17 font-weight-bold label-input">
                                    {{ item.qty*1 | number }}
                                  </div>
                                </div>
    
                                <div class="d-flex">
                                  <div class="fs-15 label-input">
                                    
                                    Harga Beli
                                  </div>
                                  <div class="ml-auto fs-17 font-weight-bold label-input">
                                    {{ item.harga_beli | price }}
                                  </div>
                                </div>
    
                                <div class="d-flex">
                                  <div class="fs-15 label-input">
                                    
                                    PPN Beli
                                  </div>
                                  <div class="ml-auto fs-17 font-weight-bold label-input">
                                    {{ item.ppn_beli }}%
                                  </div>
                                </div>
    
                                <div class="d-flex">
                                  <div class="fs-15 label-input">
                                    
                                    Harga beli include PPN
                                  </div>
                                  <div class="ml-auto fs-17 font-weight-bold label-input">
                                    {{ item.harga_beli_ppn | price }}
                                  </div>
                                </div>
    
                              </div>
                            </div>
                          </v-col>
    
    
                        </v-row>
    
                        
                      <!-- </v-card-text>
                    </v-card> -->
                    
                  </div>
                  <v-row>
                    <v-col cols="6" style="margin-top: 95px;">
                      <v-divider class="mt-4 mb-4"></v-divider>
                      <div class="d-flex">
                        <div class="fs-15 label-input">
                          
                          Total                         
                        </div>
                        <div class="ml-auto fs-17 font-weight-bold label-input">
                          {{ form.total | price }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="6" style="border-left: 1px solid #E7E7E7;">
                      <div class="d-flex">
                        <div class="fs-15 label-input">
                          
                          Harga Lainnya
                        </div>
                        <div class="ml-auto fs-17 font-weight-bold label-input">
                          {{ form.harga_lain | price }}
                        </div>
                      </div>
  
                      <div class="d-flex">
                        <div class="fs-15 label-input">
                          
                          Harga Pengiriman
                        </div>
                        <div class="ml-auto fs-17 font-weight-bold label-input">
                          {{ form.harga_pengiriman | price }}
                        </div>
                      </div>
  
                      <div class="d-flex">
                        <div class="fs-15 label-input">
                          
                          Harga Diskon
                        </div>
                        <div class="ml-auto fs-17 font-weight-bold label-input">
                          -{{ form.harga_disc | price }}
                        </div>
                      </div>
                      <v-divider class="mt-4 mb-4"></v-divider>
                      <div class="d-flex">
                        <div class="fs-15 label-input">
                          
                          Total                         
                        </div>
                        <div class="ml-auto fs-17 font-weight-bold label-input">
                          {{ form.total_update_invoice | price }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card flat class="mb-5" style="border-radius: 25px; border: 1px solid #E7E7E7;" v-if="form.update_harga_date !== ''">
                <v-card-text class="">
                  <div class="fs-17 font-weight-bold mb-4 label-input">
                    Data Harga Jual
                  </div>
                  <div class="view mt-5">
                    <div class="">
                      <table style="width: 100%" class="table">
                        <tr>
                          <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: 1px solid #ededed;" class="pa-2">
                            Nama
                          </th>
                          <!-- <th>
                            Kode SKU
                          </th> -->
                          <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                            Expired Date
                          </th>
                          <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                            Qty
                          </th>
                          <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                            Harga Beli
                          </th>
                          <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                            PPN Beli
                          </th>
                          <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                            Harga beli include PPN
                          </th>
                          <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                            Harga Hpp Per Pcs
                          </th>
                          <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                            Harga Jual Include PPN
                          </th>
                          <th style="font-size: 12px; border: 1px solid #ededed; font-weight: 600; font-color: #000; border-left: none;" class="pa-2">
                            Harga Jual Per Pcs
                          </th>
                        </tr>
                        <tr v-for="(item, index) in form.varian_arr" :key="index">
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: 1px solid #ededed;" class="pa-2">
                            {{ item.name }}
                            <div>({{ item.sku }})</div>
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                            {{ item.expired_date | date }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                            {{ item.qty*1 | number }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                            {{ item.harga_beli | price }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                            {{ item.ppn_beli }}%
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                            {{ item.harga_beli_ppn | price }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                            {{ item.harga_hpp_pcs | price }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                            {{ item.pricelist_pcs_ppn | price }}
                          </td>
                          <td style="font-size: 12px; border: 1px solid #ededed; border-left: none;" class="pa-2">
                            {{ item.pricelist_exclude_ppn | price }}
                          </td>
      
                        </tr>
                      </table>
                    </div>
                  </div>
                  <!-- <div v-for="(item, index) in form.varian_arr" :key="index">
                    <v-card flat class="mb-5" style="border-radius: 25px; border: 1px solid #E7E7E7;">
                      <v-card-text class="">
                        <div>
        
                          <div>
                            <div class="fs-16 font-weight-bold label-input">
                              {{ item.name }}
                            </div>
                            <div class="mb-1">
                              <span>Kode SKU</span>: <span>{{ item.sku }}</span>
                            </div>
                            <div class="mb-1">
                              <span>Unit</span>: <span>{{ item.unit }}</span>
                            </div>
                            <div class="mb-1">
                              <span>Expired Date</span>: <span>{{ item.expired_date | date }}</span>
                            </div>

                            <div class="d-flex">
                              <div class="">
                                
                                Qty
                              </div>
                              <div class="fs-17 font-weight-bold label-input">
                                : {{ item.qty*1 | number }}
                              </div>
                            </div>

                            <div class="d-flex">
                              <div class="">
                                
                                PPN
                              </div>
                              <div class="fs-17 font-weight-bold label-input">
                                : {{ item.ppn_beli }}%
                              </div>
                            </div>

                            <v-row class="px-3">
                              <v-col cols="6" style="border: 1px solid #E7E7E7; border-right: 0px solid; border-radius: 25px 0px 0px 0px;">
                                <div>
                                  <div class="fs-15 label-input">
                                    
                                    Harga Beli
                                  </div>
                                  <div class="fs-17 font-weight-bold label-input">
                                    {{ item.harga_beli | price }}
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="6" style="border: 1px solid #E7E7E7; border-radius: 0px 25px 0px 0px;">
                                <div>
                                  <div class="fs-15 label-input">
                                    
                                    Harga beli include PPN
                                  </div>
                                  <div class="fs-17 font-weight-bold label-input">
                                    {{ item.harga_beli_ppn | price }}
                                  </div>
                                </div>
                              </v-col>

                              <v-col cols="12" md="4" style="border: 1px solid #E7E7E7; border-right: 0px solid; border-radius: 0px 0px 0px 25px;">
                                <div>
                                  <div class="fs-15 label-input">
                                    
                                    Harga Hpp Per Pcs
                                  </div>
                                  <div class="fs-17 font-weight-bold label-input">
                                    {{ item.harga_hpp_pcs | price }}
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="12" md="4" style="border: 1px solid #E7E7E7; border-right: 0px solid; ">
                                <div>
                                  <div class="fs-15 label-input">
                                    
                                    Harga Jual Per Pcs
                                  </div>
                                  <div class="fs-17 font-weight-bold label-input">
                                    {{ item.pricelist_exclude_ppn | price }}
                                  </div>
                                </div>
                              </v-col>
                              <v-col cols="12" md="4" style="border: 1px solid #E7E7E7; border-radius: 0px 0px 25px 0px;">
                                <div>
                                  <div class="fs-15 label-input">
                                    
                                    Harga Jual Include PPN
                                  </div>
                                  <div class="fs-17 font-weight-bold label-input">
                                    {{ item.pricelist_pcs_ppn | price }}
                                  </div>
                                </div>
                              </v-col>
                            </v-row>


                          </div>
                        </div>
                      </v-card-text>
                    </v-card> 
                  </div> -->
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pt-0 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="invoice.id = form.id; invoice.harga_lain= form.harga_lain; invoice.harga_pengiriman= form.harga_pengiriman; invoice.harga_disc= form.harga_disc; dialog.form = true"
                
                :disabled="process.form"
                v-if="form.stock_date === ''"
                width="250"
                height="45"
                elevation="0"
                color="#6948c6"
                class="fs-16 white--text text-capitalize border-radius">
                Update Harga Invoice
              </v-btn>
              <v-btn 
                @click="addHargaJual()"
                :disabled="process.form || form.is_invoice === '0'"
                v-if="form.stock_date === ''"
                width="180"
                height="45"
                elevation="0"
                color="orange"
                class="fs-16 white--text text-capitalize border-radius ml-4">
                Harga Jual
              </v-btn>

              <v-btn 
                @click="form.stock_date !== '' ? '' : dialog.status = true"
                v-if="form.stock_date === ''"
                :disabled="process.form || form.update_harga_date === '' || form.stock_date !== ''"
                width="180"
                height="45"
                elevation="0"
                color="indigo"
                class="fs-16 white--text text-capitalize border-radius ml-4">
                Ready to Stok
              </v-btn>
              <!-- <v-btn 
                @click="form.stock_date !== '' ? dialog.status = true : ''"
                v-if="form.stock_date !== ''"
                width="180"
                height="45"
                elevation="0"
                color="#006064"
                class="fs-16 white--text text-capitalize border-radius ml-4">
                Close PO
              </v-btn> -->
              <v-btn
                @click="$router.go(-1)"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false,
          snackbar: false,
          form: false,
          jual: false,
          status: false,
          success: false
        },
        invoice: {id: '', harga_lain: 0, harga_pengiriman: 0, harga_disc: 0  },
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          id: '',
          po_id: '',
          number: '',
          no_surat_jalan: '',
          date: '',
          bukti_url: '',
          varian_arr: [],
          po_number: '',
          penerimaan_json: '',
          total: 0,
          harga_lain: 0,
          harga_pengiriman: 0,
          harga_disc: 0,
          update_invoice_date: '',
          is_invoice: '',
          total_update_invoice: 0,
          update_harga_date: '',
          stock_date: ''
        },
        harga: {
          id: '',
          dpp_beli: 0,
          harga_beli_ppn: 0,
          harga_lainnya: 0,
          harga_pengiriman: 0,
          harga_hpp_pcs: 0,
          harga_hpp_lusin: 0,
          harga_hpp_dus: 0
        },
        jual: {
          id: '',
          harga_hpp_pcs: 0,
          harga_jual_pcs: 0,
          harga_jual_include_ppn: 0
        },
        headers_data: [],
        supervisor: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: true,

          pdf_url: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.form = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/penerimaan/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.id = res.results.data.id
            this.form.po_id = res.results.data.po_id
            this.form.number = res.results.data.number
            this.form.no_surat_jalan = res.results.data.no_surat_jalan
            this.form.date = res.results.data.date
            this.form.bukti_url = res.results.data.bukti_url
            this.form.po_number = res.results.data.po_number
            this.form.penerimaan_json = res.results.data.penerimaan_json.length < 1 ? [] : JSON.parse(res.results.data.penerimaan_json)
            this.form.total = res.results.data.total
            this.form.harga_lain = res.results.data.harga_lain === '' ? 0 : res.results.data.harga_lain
            this.form.harga_pengiriman = res.results.data.harga_pengiriman === '' ? 0 : res.results.data.harga_pengiriman
            this.form.harga_disc = res.results.data.harga_disc === '' ? 0 : res.results.data.harga_disc
            this.form.update_invoice_date = res.results.data.update_invoice_date
            this.form.is_invoice = res.results.data.is_invoice
            this.form.update_harga_date = res.results.data.update_harga_date
            this.form.stock_date = res.results.data.stock_date
            this.form.total_update_invoice = (this.form.total*1 + this.form.harga_lain*1 + this.form.harga_pengiriman*1) - this.form.harga_disc*1
            this.form.varian_arr = res.results.data.detail.map(item => {
              return {
                id: item.penerimaan_detail_varian_id,
                detail_id: item.penerimaan_detail_id,
                sku: item.penerimaan_detail_varian_sku,
                name: item.penerimaan_detail_varian_name,
                unit: item.penerimaan_detail_varian_unit,
                qty: item.penerimaan_detail_qty,
                harga_beli: item.penerimaan_detail_harga_beli,
                ppn_beli: item.penerimaan_detail_ppn_beli,
                expired_date: item.penerimaan_detail_expired_date,
                pricelist_pcs_ppn_before: item.pricelist_pcs_ppn,

                dpp_jual: 0,
                biaya_lainnya_jual_1: 0,
                biaya_lainnya_jual_2: 0,
                pricelist_exclude_ppn: item.penerimaan_detail_pricelist_exclude_ppn,
                pricelist_pcs_ppn: item.penerimaan_detail_pricelist_pcs_ppn,
                pricelist_lusin_ppn: 0,
                pricelist_dus_ppn: 0,
                harga_beli_ppn: item.penerimaan_detail_harga_beli*1 + (item.penerimaan_detail_harga_beli*1 * (item.penerimaan_detail_ppn_beli*1/100)),
                dpp_beli: item.penerimaan_detail_dpp_beli === undefined ? item.penerimaan_detail_harga_beli : item.penerimaan_detail_dpp_beli,
                harga_lainnya: 0,
                harga_pengiriman: 0,
                harga_hpp_pcs: item.penerimaan_detail_harga_hpp_pcs,
                // harga_hpp_pcs: item.penerimaan_detail_dpp_beli === undefined ? item.penerimaan_detail_harga_beli : item.penerimaan_detail_dpp_beli + item.penerimaan_detail_harga_pengiriman === undefined ? 0 : item.penerimaan_detail_harga_pengiriman + item.penerimaan_detail_harga_lainnya === undefined ? 0 : item.penerimaan_detail_harga_lainnya,
                harga_hpp_lusin: 0,
                harga_hpp_dus: 0
              }
            })
            // this.menu = res.results.data.detail.map(item => {
            //   return {
            //     menu: false
            //   }
            // })
            // this.bukti = res.results.data.bukti_url.includes('.pdf') ? 'pdf' : 'gambar'
            // this.gambar_url = this.bukti === 'gambar' ? res.results.data.bukti_url : ''
            // this.pdf_url = this.bukti === 'pdf' ? res.results.data.bukti_url : ''
            
          }
          // this.fetchSales()
          this.process.form = false

          this.fetchPembelian()
          
        })
      },

      addHargaJual() {
        this.form.varian_arr.map(item => {
          item.harga_hpp_pcs = item.harga_hpp_pcs === '' || item.harga_hpp_pcs*1 === 0 ? item.harga_beli*1 + ((this.form.harga_lain*1)/(item.qty*1)) + ((this.form.harga_pengiriman*1)/(item.qty*1)) - ((this.form.harga_disc*1)/(item.qty*1)) : item.harga_hpp_pcs
        })
        this.dialog.jual = true
      },

      reset(item) {
        this.errors.message = ''
        this.harga = {
          varian_id: item.id,
          dpp_beli: item.harga_beli,
          ppn_beli: item.ppn_beli,
          harga_beli_ppn: item.harga_beli + item.ppn_beli,
          harga_lainnya: 0,
          harga_pengiriman: 0,
          harga_hpp_pcs: 0,
          harga_hpp_lusin: 0,
          harga_hpp_dus: 0,

          dpp_jual: 0,
                biaya_lainnya_jual_1: 0,
                biaya_lainnya_jual_2: 0,
                pricelist_exclude_ppn: 0,
                pricelist_pcs_ppn: 0,
                pricelist_lusin_ppn: 0,
                pricelist_dus_ppn: 0
        }
        this.dialog.form = true
      },

      change_harga_jual_ppn(index) {
        // this.form.varian_arr[index].pricelist_pcs_ppn = (this.form.varian_arr[index].pricelist_exclude_ppn*1)+((this.form.varian_arr[index].pricelist_exclude_ppn*1)*(this.form.varian_arr[index].ppn_beli*1/100))
        this.form.varian_arr[index].pricelist_exclude_ppn = 100/(100+(this.form.varian_arr[index].ppn_beli*1))*(this.form.varian_arr[index].pricelist_pcs_ppn*1)
      },

      change_harga_beli_ppn(index) {
        this.form.varian_arr[index].harga_beli_ppn = this.form.varian_arr[index].dpp_beli*1 + this.form.varian_arr[index].ppn_beli*1
      },
      change_harga_hpp_pcs(index) {
        this.form.varian_arr[index].harga_hpp_pcs = this.form.varian_arr[index].dpp_beli*1 + this.form.varian_arr[index].harga_pengiriman*1 + this.form.varian_arr[index].harga_lainnya*1
      },
      change_dpp_beli(index) {
        this.form.varian_arr[index].harga_hpp_pcs = this.form.varian_arr[index].dpp_beli*1 + this.form.varian_arr[index].harga_pengiriman*1 + this.form.varian_arr[index].harga_lainnya*1
        this.form.varian_arr[index].harga_beli_ppn = this.form.varian_arr[index].dpp_beli*1 + this.form.varian_arr[index].ppn_beli*1
      },
      async fetchPembelian () {
        this.process.load = true

        let params = {
          limit: 1000000,
          status: 'terbit'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/pembelian/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            
          }
          this.process.load = false
        })
      },
      changePembelian() {
        this.fetchDetailPembelian()
      },
      async fetchDetailPembelian () {
        let params = {
          id: this.form.po_id
        }

        await get('admin/pembelian/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.varian_arr = res.results.data.detail.map(item => {
              return {
                id: item.po_detail_varian_id,
                sku: item.po_detail_varian_sku,
                name: item.po_detail_varian_name,
                unit: item.po_detail_varian_unit,
                qty: item.po_detail_qty,
                harga_beli: item.po_detail_harga_beli,
                ppn_beli: item.po_detail_ppn_beli,
                expired_date: ''
              }
            })
            this.menu = res.results.data.detail.map(item => {
              return {
                menu: false
              }
            })
          }
          this.process.load = false
        })
      },
      async saveStok() {
        let form = {
          id: this.form.id
        }
        this.process.form = true

        // SAVE TO REST API
        await post(`admin/penerimaan/ready_stock`, {
          data: form
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.fetchDetail()
            this.dialog.status = false
            this.message.success = res.message
            this.dialog.success = true

          } else {
            this.message.error = res.message
          }
        })
      },
      async saveHargaJual() {
        this.process.form = true
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            id: this.form.id,
            varian_arr: JSON.stringify(this.form.varian_arr.map(item => {
              return {
                detail_id: item.detail_id,
                varian_id: item.id,
                pricelist_exclude_ppn: item.pricelist_exclude_ppn,
                pricelist_pcs_ppn: item.pricelist_pcs_ppn,
                harga_hpp_pcs: item.harga_hpp_pcs
                
              }
            })),
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/penerimaan/update_harga_jual`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.fetchDetail()
              this.dialog.jual = false
              this.message.success = res.message
              this.snackbar = true

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async save () {
        this.process.form = true
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ... this.invoice,
            // id: this.form.id,
            // varian_arr: JSON.stringify(this.form.varian_arr.map(item => {
            //   return {
            //     varian_id: item.id,
            //     ppn_beli: item.ppn_beli,
            //     dpp_jual: item.dpp_jual,
            //     biaya_lainnya_jual_1: item.biaya_lainnya_jual_1,
            //     biaya_lainnya_jual_2: item.biaya_lainnya_jual_2,
            //     pricelist_exclude_ppn: item.pricelist_exclude_ppn,
            //     pricelist_pcs_ppn: item.pricelist_pcs_ppn,
            //     pricelist_lusin_ppn: item.pricelist_lusin_ppn,
            //     pricelist_dus_ppn: item.pricelist_dus_ppn,
            //     harga_beli_ppn: item.harga_beli_ppn,
            //     dpp_beli: item.dpp_beli,
            //     harga_lainnya: item.harga_lainnya,
            //     harga_pengiriman: item.harga_pengiriman,
            //     harga_hpp_pcs: item.harga_hpp_pcs,
            //     harga_hpp_lusin: item.harga_hpp_lusin,
            //     harga_hpp_dus:  item.harga_hpp_dus
                
            //   }
            // })),
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/penerimaan/update_invoice`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.fetchDetail()
              this.dialog.form = false
              this.message.success = res.message
              this.snackbar = true

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style>
table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    /* width: 100%; */
  }

  .wrapper-harga-jual { 
    overflow-y: auto; 
    height: calc(100vh - 175px); 
  } 

  .wrapper-harga-jual-none { 
    /* overflow-y: auto; 
    height: calc(100vh - 270px);  */
  } 

  .wrapper-harga-jual th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }

  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
</style>